export default "__VITE_ASSET__Chs4Mhab__"